
import { QueryClient } from '@tanstack/react-query';

// Create a client with optimized configuration
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // 30 seconds for fresher data
      gcTime: 600000, // 10 minutes in cache (increased from default)
      retry: 1,
      refetchOnWindowFocus: true, // always refetch on window focus
      refetchOnMount: false, // Don't refetch on mount if data exists
      refetchOnReconnect: true,
    },
    mutations: {
      // Never auto-retry mutations. Mutations are side-effectful
      // (create / update / delete); retrying on failure double-fires
      // toasts and can double-create rows on transient 5xx. One click
      // = one attempt = one toast — the operator sees the error and
      // decides whether to retry manually.
      retry: false,
    },
  },
});
